import React, { type ErrorInfo, type PropsWithChildren } from "react";
import ErrorLayout from "@/features/ErrorLayout";

interface ErrorBoundaryState {
  hasError: boolean;
  error: any;
}

export class ErrorBoundary extends React.Component<
  PropsWithChildren,
  ErrorBoundaryState
> {
  constructor(props: PropsWithChildren) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Error catched in ErrorBoundary: ", error, info);
  }

  render() {
    if (this.state.hasError) {
      return <ErrorLayout errorMessage={this.state.error?.message} />;
    }

    return this.props.children;
  }
}
